import dayjs from 'dayjs';
import { t } from 'i18next';
import isNil from 'lodash/isNil';
import { TradingTimesFormSchema } from 'pos-shared/models/openingHoursGroupSchema.ts';
import { RMAssetFormSchema } from 'pos-shared/models/resourceManagementSchema';

export const TradingTimesRefinedFormSchema = TradingTimesFormSchema.superRefine(
  (data, ctx) => {
    if (
      !isNil(data.opening) &&
      !isNil(data.closing) &&
      dayjs(data.closing).isBefore(data.opening, 'seconds')
    ) {
      ctx.addIssue({
        code: 'custom',
        message: t('locations.trading.closingTimeGreaterError'),
        path: ['closing'],
      });
    }
  }
);

export const RMAssetFormRefinedSchema = RMAssetFormSchema.superRefine(
  (data, ctx) => {
    if (data.asset === undefined) {
      ctx.addIssue({
        code: 'custom',
        message: t('routes.validationErrors.needAsset'),
        path: ['asset'],
      });
    }

    if (data.technician === undefined) {
      ctx.addIssue({
        code: 'custom',
        message: t('routes.validationErrors.needTechnician'),
        path: ['technician'],
      });
    }
  }
);
